import { keyframes, css } from 'styled-components';

const ping = keyframes([
  `75%,100%{transform:scale(2);opacity:0;}`
]);
const pulseKeyframes = keyframes([
  `0%{opacity:1;}50%{opacity:0.6;}100%{opacity:1;}`
]);
const cssAnimations = {
  ping: {
    keyframe: ping,
    animate: css([
      `animation:`,
      ` 1s cubic-bezier(0,0,0.2,1) infinite;`
    ], ping)
  },
  pulse: {
    keyframe: pulseKeyframes,
    animate: css([
      `animation:`,
      ` 1s ease-in-out infinite;`
    ], pulseKeyframes)
  }
};

export { cssAnimations, pulseKeyframes };
//# sourceMappingURL=cssAnimations.js.map
